import { baseUrl, getBaseApiUrl } from "./../env";
import BaseAPI from "./baseAPI";
export let  getStudentid = window.location.pathname.split("/")[4];
let params = new URL(document.location).searchParams;
let section_id = params.get("section_id");


const getQuizUrl = (quiz_id) => `${getBaseApiUrl()}/speak/test/${quiz_id}/?id=${getStudentid}`;
const getReviewTestUrl = (quiz_id) => `${getBaseApiUrl()}/speak/test/${quiz_id}/?section_id=${section_id}`;
const gettestSubmissionUrl = (quiz_id) => `${baseUrl}/student_test_status/${quiz_id}`;

class API extends BaseAPI {
  constructor(props) {
    super(props);
    this.props = props;
  }

  get = ({ id }) => {
    if (section_id)
    {
      return this.fetchSecure({ url: getReviewTestUrl(id) });
    }
    else{
      return this.fetchSecure({ url: getQuizUrl(id) });
    }
  };


  get_submission_status = ({ id }) => {
    return this.fetchSecure({ url: gettestSubmissionUrl(id) });
  };

  post = ({ id, data }) => {
    return this.postSecure({ url: getQuizUrl(id), data });
  };
  
}

export default new API();
